export const PERM_ACTIONS = [
  {
    key: "can_view",
    label: "View",
    short: "V",
    tone: "view",
  },
  {
    key: "can_create",
    label: "Create",
    short: "C",
    tone: "create",
  },
  {
    key: "can_edit",
    label: "Edit",
    short: "E",
    tone: "edit",
  },
  {
    key: "can_delete",
    label: "Delete",
    short: "D",
    tone: "delete",
  },
];

export function countRowPermissions(row) {
  return PERM_ACTIONS.filter((a) => Number(row[a.key]) === 1).length;
}
